export interface IWarehouseAdminProductLocationData {
    id: number;
    product_id: number;
    location_id: number;
    location_name: string|null;
    place: string|null;
    rack: string|null;
    layer: string|null;
    sort: number;
}

export default class WarehouseAdminProductLocationData {
    public id: number;
    public product_id: number;
    public location_id: number;
    public location_name: string|null;
    public place: string|null;
    public rack: string|null;
    public layer: string|null;
    public sort: number;

    constructor(data: IWarehouseAdminProductLocationData) {
        this.id = Number(data.id);
        this.product_id = Number(data.product_id);
        this.location_id = Number(data.location_id);
        this.location_name = data.location_name ?? null;
        this.place = data.place ?? null;
        this.rack = data.rack ?? null;
        this.layer = data.layer ?? null;
        this.sort = Number(data.sort);
    }
}